import { z } from 'zod'
import { PaymentStatusSchema, PaymentTypeSchema } from './payments.schema'
import { ServiceFeePayerSchema } from '@/apis/payments/service_fee.schema'

export const TransactionListItemSchema = z.object({
  payment_id: z.number().int().positive(),
  status: PaymentStatusSchema,
  type: PaymentTypeSchema,
  transaction_type: z.string().nullable(),
  amount_provider: z.number(),
  transaction_id: z.number(),
  program_id: z.number().int().positive(),
  student_name: z.array(z.string()),
  applicant_name: z.string(),
  provider_id: z.number().nullable(),
  provider_name: z.string().nullable(),
  created_datetime: z.string().datetime(),
  service_fee_payer: ServiceFeePayerSchema,
  service_fee: z.number(),
  invoice_quote: z.string().nullable(),
  total_amount: z.number(),
  comments: z.string().nullable(),
})
export type TransactionListItem = z.infer<typeof TransactionListItemSchema>
